import React from "react";
import _ from "lodash";
import { EuiFlexItem } from "@elastic/eui";
import TripDetailsSection from "../TripDetailsSection";

export default function TripTypeDetails({
    label,
    options,
    tripTypeName,
    onChange,
    isEditable,
    onConfirmingField,
    isConfirmed,
}) {
    return (
        <EuiFlexItem>
            <TripDetailsSection
                label={label}
                options={options}
                selectedValue={tripTypeName}
                onSelectChange={onChange}
                isEditable={isEditable}
                onConfirmingField={onConfirmingField}
                isConfirmed={isConfirmed}
            />
        </EuiFlexItem>
    );
}
